{
  "static-content-download-app": {
    "buttons": {},
    "text": {
      "title": "Beauty Booking App herunterladen",
      "description": "Erlebe eine Welt voller Komfort! Lade noch heute unsere App herunter und erhalte nahtlosen Zugriff auf unsere Dienstleistungen!"
    }
  }
}
